<script>
  import LoggedOutRoute from "./components/LoggedOutRoute.svelte"
  import ProtectedRoute from "./components/ProtectedRoute.svelte"
  import { Router, Link, Route } from "svelte-routing"
  import { navigate } from "svelte-routing"
  import initialize from "./lib/initialize"
  import { initialized, me, gameId } from "./store"
  import NameSetup from "./components/NameSetup.svelte"
  import Game from "./components/Game.svelte"
  import GameSetup from "./components/GameSetup.svelte"

  export let url = ""

  initialize().then(() => {})
</script>

<style lang="scss">
  @import "./vars";
  main {
    display: grid;
    height: 100%;
    grid-template-rows: 4rem 1fr;
  }
  header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $white;
    height: 4rem;
    padding: 0 1rem;
    h1 {
      margin: 0;
      font-family: Produkt;
      color: $green;
      font-size: 1.2rem;
      color: $black;
    }
    > div {
      display: grid;
      grid-auto-flow: column;
      justify-content: center;
      align-items: center;
      img {
        width: 2.2rem;
        height: 2.1rem;
        margin-right: 0.6rem;
      }
    }
  }
  .content {
    padding: 2rem;
    background: $gray;
    grid-row: 2;
    @include below(bigphone) {
      padding: 1rem;
    }
  }
</style>

<main class:initialized={$initialized}>
  <header>
    <div>
      <img src="/images/globe.png" />
      <h1>Dream WDS Generator</h1>
    </div>
  </header>
  <div class="content">
    {#if $me && $gameId}
      <Game />
    {:else if !$me}
      <NameSetup />
    {:else if !$gameId}
      <GameSetup />
    {/if}
  </div>
</main>
